import { Chip } from "@material-tailwind/react";

export function ChipDefault() {
  return <Chip value="chip" />;
}
